<template>
    <div class="body">
        <div class="top-box-top">
            <top />
        </div>
        <div class="bottom-box">
            <basecom />
            <div class="list">
                <div class="medical-list">
                  <div class="search">
                      <moduleSearch
                      :search="search"
                      :reset="reset"
                      :numTotal="numTotal"
                      ></moduleSearch>
                  </div>
                  <moduleTypelist
                  :header-cell-style="{ 
                  background:'#000',color:'#fff'}"
                  :tableHeader="this.modulelogic.opHeader()"
                  :tableData="moduleTypeList"
                  :page="this.modulelogic.searchObj.page"
                  :row-class-name="tableRowClassName"
                  >
                      <template v-slot:btn="slotProps">
                          <el-button type="danger" @click="editModule(slotProps.row)">
                              删除模块类型
                          </el-button>
                      </template>
                  </moduleTypelist>
                  <pager
                  :page="this.modulelogic.searchObj.page"
                  :numTotal="numTotal"
                  :handleCurrentChange="handleCurrentChange"
                  >
                  </pager>
                </div>
            </div>
        </div>
    </div>
  </template>
  <script>
  import basecom from "@/components/base";
  import moduleTypelist from "@/components/listComponents/pagerList";
  import top from "@/components/top.vue";
  import pager from "@/components/listComponents/pager.vue";
  import moduleSearch from "@/components/searchComponents/moduleSearch.vue";
  export default {
    components: {
      moduleTypelist,
      pager,
      moduleSearch,
      top,
      basecom
    },
    data() {
      return {
        moduleTypeList: [],
        page: 1,
        numTotal: 0,
      };
    },
    mounted() {
      this.search();
    },
    methods: {
      tableRowClassName({row, rowIndex}) {
        if(rowIndex%2==1){
            return 'warning-row';
        }else{
            return 'success-row';
        }
      },
      handleCurrentChange: function (page) {
        this.modulelogic.searchObj.page = page;
        this.modulelogic.getModuleList().then((res) => {
          this.moduleTypeList = res.moduleTypeList;
          this.numTotal = res.total;
        });
      },
      sureDeleteModule() {
        var aa = {
          id:this.mbID
        }
        this.axios(
            {   method: "delete",
                url: this.baseURL + "ModuleType/ModuleTypeDelete",
                data: aa,
                headers: this.header(),
            }
        ).then((res) => {
          this.resolveData(res.data, "delete");
        });
      },
      editModule(row) {
        this.mbID = row.id;
        this.$confirm('确定要删除该模块类型吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.sureDeleteModule()
        })
      },
      reset() {
        window.location.reload()
      },
      search() {
        this.handleCurrentChange();
      },
    },
  };
  </script>
  